/* Gleam Beauty — accessibility fixes (WCAG 2.1 AA). Added Oct 2026. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Pause/play control on every autoplaying or looping video (WCAG 2.2.2)
  function addVideoControls(root) {
    (root || document).querySelectorAll('video').forEach(function (v) {
      if (v.dataset.adaDone) return;
      if (!(v.autoplay || v.loop || v.hasAttribute('autoplay'))) return;
      if (v.controls) return;
      v.dataset.adaDone = '1';
      v.setAttribute('aria-hidden', 'true');
      var host = v.parentElement;
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.classList.add('ada-video-wrap');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ada-video-toggle';
      var setState = function () {
        var paused = v.paused;
        btn.textContent = paused ? 'Play' : 'Pause';
        btn.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' background video');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      };
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { v.play(); v.dataset.adaUserPaused = ''; }
        else { v.pause(); v.dataset.adaUserPaused = '1'; }
      });
      v.addEventListener('play', function () {
        if (v.dataset.adaUserPaused === '1') { v.pause(); }
        setState();
      });
      v.addEventListener('pause', setState);
      if (reduceMotion) { v.dataset.adaUserPaused = '1'; v.pause(); }
      host.appendChild(btn);
      setState();
    });
  }

  // 2. aria-controls must point at an element that exists (WCAG 4.1.2)
  function fixAriaControls() {
    document.querySelectorAll('[aria-controls]').forEach(function (el) {
      var ids = el.getAttribute('aria-controls').split(/\s+/).filter(function (id) {
        return id && document.getElementById(id);
      });
      if (ids.length) el.setAttribute('aria-controls', ids.join(' '));
      else el.removeAttribute('aria-controls');
    });
  }

  // 3. Links with no accessible name (image-only links) (WCAG 2.4.4 / 4.1.2)
  function nameFromHref(href) {
    try {
      var p = new URL(href, location.href).pathname;
      if (/^\/products\//.test(p) || /\/products\//.test(p)) {
        var h = p.split('/products/')[1].split('/')[0];
        return 'View product: ' + h.replace(/-/g, ' ');
      }
      if (/^\/collections\/all\/?$/.test(p)) return 'Shop all products';
      if (/^\/collections\//.test(p)) return 'Shop the collection';
      if (/^\/pages\//.test(p)) return 'Learn more: ' + p.split('/pages/')[1].replace(/-/g, ' ');
    } catch (e) {}
    return 'Learn more';
  }
  function fixLinkNames(root) {
    (root || document).querySelectorAll('a[href]').forEach(function (a) {
      if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) return;
      if ((a.textContent || '').trim()) return;
      var img = a.querySelector('img[alt]:not([alt=""])');
      if (img) return;
      var titled = a.querySelector('[title]');
      if (titled && titled.getAttribute('title').trim()) return;
      // Prefer a product/section heading near the link
      var card = a.closest('.grid-product, .grid__item, .feature-row, [class*="product-card"]');
      var heading = card && card.querySelector('h2, h3, h4, h5, .grid-product__title');
      var label = heading && heading.textContent.trim();
      a.setAttribute('aria-label', label || nameFromHref(a.getAttribute('href')));
    });
  }

  // 4. Autocomplete on contact / newsletter fields (WCAG 1.3.5)
  function fixAutocomplete() {
    var map = { 'contact[name]': 'name', 'contact[email]': 'email', 'contact[phone]': 'tel', 'contact[first_name]': 'given-name', 'contact[last_name]': 'family-name' };
    Object.keys(map).forEach(function (n) {
      document.querySelectorAll('[name="' + n + '"]').forEach(function (el) {
        if (!el.getAttribute('autocomplete') || el.getAttribute('autocomplete') === 'off') el.setAttribute('autocomplete', map[n]);
      });
    });
    document.querySelectorAll('input[type="email"]').forEach(function (el) {
      if (!el.getAttribute('autocomplete') || el.getAttribute('autocomplete') === 'off') el.setAttribute('autocomplete', 'email');
    });
    var body = document.querySelector('[name="contact[body]"]');
    if (body) body.setAttribute('aria-required', 'true');
  }

  // 5. Unnamed iframes (tracking pixels) get a title (WCAG 4.1.2)
  function fixIframes() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      f.setAttribute('title', /web-pixels/.test(f.src || '') ? 'Analytics (no visible content)' : 'Embedded content');
      if (/web-pixels/.test(f.src || '')) f.setAttribute('aria-hidden', 'true');
    });
  }

  // 6. Every page needs one H1 (WCAG 1.3.1 / 2.4.6)
  function fixH1() {
    var main = document.getElementById('MainContent');
    if (!main || document.querySelector('h1')) return;
    var isProduct = document.body.classList.contains('template-product');
    var promote = isProduct ? main.querySelector('.product-single__meta h2, .product-single__meta h3, .product-single__meta h4') : null;
    if (promote) {
      var h1 = document.createElement('h1');
      for (var i = 0; i < promote.attributes.length; i++) h1.setAttribute(promote.attributes[i].name, promote.attributes[i].value);
      h1.innerHTML = promote.innerHTML;
      promote.parentNode.replaceChild(h1, promote);
      return;
    }
    var og = document.querySelector('meta[property="og:title"]');
    var title = (og && og.content) || document.title;
    title = title.replace(/\s*[–|-]\s*Gleam Beauty.*$/i, '').trim();
    var h = document.createElement('h1');
    h.className = 'visually-hidden';
    h.textContent = title;
    main.insertBefore(h, main.firstChild);
  }

  // 7. Scrollable regions must be keyboard reachable (WCAG 2.1.1)
  function fixScrollRegions() {
    document.querySelectorAll('.float-grid, [class*="scroller"], [class*="slider"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      var scrolls = /(auto|scroll)/.test(cs.overflowX + cs.overflowY) && (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
      if (!scrolls || el.hasAttribute('tabindex')) return;
      if (el.querySelector('a[href], button, input, select, textarea, [tabindex]')) return;
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'region');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable content');
    });
  }

  function runAll(root) {
    addVideoControls(root); fixLinkNames(root); fixAriaControls(); fixAutocomplete(); fixIframes(); fixH1(); fixScrollRegions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { runAll(); });
  else runAll();
  window.addEventListener('load', function () { runAll(); });

  // Catch content injected later (apps, lazy sections, cart drawer)
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { runAll(); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
